import { imageSrc } from "@/lib/utils";

const SUPABASE_LOGOS =
  "https://qlxnmbgtohaiyhbzfvvc.supabase.co/storage/v1/object/public/Logos";
const CALLJAA = "https://www.calljaa.com/wp-content/plugins/jaa-fuel-manager/images";

/** Brand logos when a station row has no valid stationLogo (matches Shift iOS assets). */
const BRAND_LOGO_BY_NAME: Record<string, string> = {
  FESCO: `${SUPABASE_LOGOS}/fesco-logo-new.png`,
  "TOTAL JAMAICA": `${SUPABASE_LOGOS}/totalenergies_logo_rgb.png`,
  "COOL OASIS": `${SUPABASE_LOGOS}/Cool-Oasis-logo-Converted.png`,
  RUBIS: `${CALLJAA}/rubis.png`,
  TEXACO: `${CALLJAA}/texaco.png`,
  PETCOM: `${CALLJAA}/petcom.png`,
  UNIPET: `${CALLJAA}/unipet.png`,
};

type StationLike = {
  name: string;
  stationLogo?: string | null;
  stationImage?: string | null;
};

export function resolveStationLogo(station: StationLike): string | null {
  const fromRow = imageSrc(station.stationLogo) ?? imageSrc(station.stationImage);
  if (fromRow) return fromRow;

  const brandKey = station.name.trim().toUpperCase();
  return imageSrc(BRAND_LOGO_BY_NAME[brandKey]);
}
